/** Para as janelas flutuantes que ficam sempre montadas e só se
 *  desenham quando abertas (`if (!open) return null`): o
 *  `useJanelaNaFrente` só entra na ordem ao montar, por isso aqui a
 *  janela vem para a frente cada vez que abre e sai da ordem quando
 *  fecha. Ver camadas.ts. */
import { useEffect } from 'react'
import {
  largarJanela,
  trazerParaAFrente,
  useJanelaNaFrente,
  type GrupoDeJanelas,
} from './camadas'

export function useJanelaAberta(
  id: string,
  aberta: boolean,
  grupo: GrupoDeJanelas = 'pagina',
): { z: number; trazer: () => void } {
  const camada = useJanelaNaFrente(id, grupo)
  // Corre depois do efeito do useJanelaNaFrente (mesma ordem de declaração).
  useEffect(() => {
    if (aberta) trazerParaAFrente(id, grupo)
    else largarJanela(id, grupo)
  }, [id, aberta, grupo])
  return camada
}
